<div class="d-flex flex-row-reverse shortcut-highlight top-short-key pb-3">
  <a class="px-3 py-1 anchoroutline" *ngFor="let item of iLeftnavList let i = index"
    data-toggle="tooltip" data-placement="bottom"
    title="{{item.text}}"  href="{{item.hyperlink}}" target="_blank">
    <img class="shortcutimg" src="{{item.icon}}"  alt="shortcuts" />
  </a>
</div>

